import { Container, Text } from '@mantine/core';
import dayjs from 'dayjs';
import classes from './Footer.module.css';

export function Footer() {
    return (
        <div className={classes.footer}>
            <Container className={classes.inner}>
                <Text size="sm" c="dimmed" fw={500}>©{dayjs().get('y')} Indesil S.r.l.</Text>
            </Container>
        </div>
    );
}